import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UnitsI } from '@iris/common/models/Units';

@Injectable({
  providedIn: 'root',
})
export class IrisUtilsService {
  protected _httpClient = inject(HttpClient);

  public getUnitsList(): Observable<UnitsI> {
    return this._httpClient.get<UnitsI>('/system/iris-units');
  }
}
